const state = {
  userData: null
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js